import { render, staticRenderFns } from "./NotaDeEgreso.vue?vue&type=template&id=5636062b&scoped=true&"
import script from "./NotaDeEgreso.vue?vue&type=script&lang=js&"
export * from "./NotaDeEgreso.vue?vue&type=script&lang=js&"
import style0 from "./NotaDeEgreso.vue?vue&type=style&index=0&id=5636062b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5636062b",
  null
  
)

export default component.exports